export default "__VITE_ASSET__CAtYESar__"